import './AdventCalendar.scss';
import './AdventCalendarWindow.scss';
import './ChristmasBulb.scss';

/**
 * @param {HTMLDivElement?} previousBulb
 * @param {HTMLDivElement} bulb
 * @param {number} i
 */
const displaceChristmasBulb = (previousBulb, bulb, i) => {
    bulb.style.zIndex = 24 - i + '';
    bulb.style.marginLeft = randomSpacing(30, -45);
    bulb.style.marginRight = randomSpacing(10, -15);
    bulb.style.marginTop = randomSpacing(30, 60);
    bulb.style.marginBottom = randomSpacing(30, -20);
    // bulb.style.transform = `rotate(${Math.random() * 16 - 8}deg)`;
    bulb.style.animationDelay = `${-Math.floor(Math.random() * 90) / 10}s`;
    //bulb.style.animationName = ['','swing-small2', 'swing-small'][Math.floor(Math.random() * 3)];
    bulb.style.animationName = Math.random() > 0.4 ? availableAnimations[Math.floor(Math.random() * availableAnimations.length)] : null;
};

/**
 * @param {number} i
 * @param {number} base
 * @returns {number}
 */
const halton = (i, base) => {
    let res = 0;
    let f = 1;
    while (i > 0) {
        res = res + f * (i % base);
        i = Math.floor(i / base);
        f = f / base;
    }
    return res;
};

/**
 * @param {function(number): HTMLElement} elementRenderer
 * @param {number} elementCount
 * @param {HTMLDivElement} elementContainer
 * @param {{ density?: number, height?: number, baseX?: number, baseY?: number }} options
 */
const distributeElements = (elementRenderer, elementCount, elementContainer, options = {}) => {
    const frag = document.createDocumentFragment();
    const baseX = options.baseX || 2;
    const baseY = options.baseY || 3;
    for (let i = 0; i < elementCount; i++) {
        const element = elementRenderer(i);
        element.style.position = 'absolute';
        element.style.left = `${Math.max(10, halton(i, baseX) * 90)}%`;
        element.style.top = `${halton(i, baseY) * options.density || 100}px`;
        frag.appendChild(element);
    }
    elementContainer.appendChild(frag);
};

/**
 * @template T
 * @param {T[]} a
 * @returns {T}
 */
const pick = a => a[Math.floor(Math.random() * a.length)];

const snowFlakeContainer = document.querySelector('.adventcalendar__snowflake__container');
if (snowFlakeContainer) {
    const snowFlakeVariants = [ 'adventcalendar__snowflake--star', 'adventcalendar__snowflake--dot' ];
    const snowFlakeRender = () => {
        // the flare variant is a bit more problematic when cut off by the container
        // const className = Math.random() > 0.95 ? 'adventcalendar__snowflake--flare' : pick(snowFlakeVariants);
        const className = pick(snowFlakeVariants);
        const el = Object.assign(document.createElement('span'), { className: className });
        el.style.transform = `scale(${Math.floor(Math.random() * 40 + 60) / 100}) rotate(${Math.floor(Math.random() * 360)}deg)`;
        return el;
    };
    distributeElements(snowFlakeRender, 30, snowFlakeContainer, { density: 200 });
}


const availableAnimations = [ 'swingLeft', 'swingRight' ];

const randomSpacing = (leeway, min = 0) => Math.floor(Math.random() * leeway + min) + 'px';

if (document.querySelector('.christmas-bulb')) {
    Array.from(document.querySelectorAll('.christmas-bulb')).reduce(displaceChristmasBulb, null);
}
